import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from '@mui/material';

const Pill = (props) => {
  const {
    children,
    label,
    variant='neutral',
    backgroundColor,
    borderColor,
    textColor,
    sx,
    labelSx,
    ...containerBoxProps
  } = props;

  const variantStyles = {
    warning: {
      backgroundColor: '#FFFBEB',
      borderColor: '#FDE68A',
      color: '#D97706',
    },
    info: {
      backgroundColor: '#EFF6FF',
      borderColor: '#BFDBFE',
      color: '#2563EB',
    },
    neutral: {
      backgroundColor: '#F9F8F6',
      borderColor: '#E8E4DE',
      color: '#6B6760',
    },
  };

  const currentVariantStyles = variantStyles[variant] ?? variantStyles.neutral;
  const content = label ?? children;

  return (
    <Box
      component='span'
      sx={{
        boxSizing: 'border-box',
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        gap: '10px',
        px: '9px',
        py: '4px',
        height: '22px',
        border: '1px solid',
        borderColor: borderColor ?? currentVariantStyles.borderColor,
        borderRadius: '20px',
        backgroundColor: backgroundColor ?? currentVariantStyles.backgroundColor,
        whiteSpace: 'nowrap',
        ...sx,
      }}
      {...containerBoxProps}
    >
      <Typography
        component='span'
        sx={{
          fontFamily: '"Roboto Mono", monospace',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '11px',
          lineHeight: '14px',
          color: textColor ?? currentVariantStyles.color,
          ...labelSx,
        }}
      >
        {content}
      </Typography>
    </Box>
  );
};

Pill.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.node,
  labelSx: PropTypes.object,
  sx: PropTypes.object,
  textColor: PropTypes.string,
  variant: PropTypes.oneOf(['warning', 'info', 'neutral']),
};

export default React.memo(Pill);
